import cn from 'classnames'
import { Icon } from '../icon'
import styles from './IconCell.module.css'
import { IconCellProps } from './IconCell.types'

export default function IconCell({
  glyph,
  size = 'md',
  hidden = false,
  verticalAlignment = 'center',
  className,
}: IconCellProps) {
  return (
    <div
      className={cn(
        styles.iconCell,
        size === 'sm' && styles.sizeSm,
        size === 'md' && styles.sizeMd,
        size === 'lg' && styles.sizeLg,
        verticalAlignment === 'top' && styles.alignTop,
        verticalAlignment === 'center' && styles.alignCenter,
        className,
      )}
    >
      {!hidden && <Icon glyph={glyph} fullWidth />}
    </div>
  )
}
